export default __webpack_public_path__ + "static/media/ic_esport.b2fec892.jpg";